import calls from '@/backend/api-calls'

const state = () => ({
  skids: [],
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
}

// actions
const actions = {
  getSkids: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.cutsheetSkids.get(parameters)
        .then(resp => {
          commit("setSkids", resp.data.results);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addSkid: ({commit}, {data, parameters}) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSkids.post(data, parameters)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Skid successfully added'
            },
            { root: true }
          );
          commit("insertSkid", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteSkid: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSkids.delete(id)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Skid successfully deleted'
            },
            { root: true }
          );
          commit("removeSkid", id);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateSkid: ({commit}, { skidId, data }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSkids.put(skidId, data)
        .then(resp => {
          commit("insertUpdatedSkid", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deletePart: ({commit}, { skidId, partId }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetPart.put(partId, { skid_id: null })
        .then(resp => {
          commit("removePart", { 
            skidId: skidId, partId: partId 
          });
          resolve(resp)
        }).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  changePage(state, page) {
    state.pagination.page = page;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setSkids (state, data) {
    state.skids = data;
  },
  insertSkid (state, data) {
    state.skids.push(data);
  },
  removeSkid (state, id) {
    let ids = state.skids.map(d => d.id);
    let index = ids.indexOf(id);
    state.skids.splice(index, 1);
  },
  insertUpdatedSkid (state, data) {
    state.skids.forEach((skid, i) => {
      if (skid.id == data.id) {
        state.skids.splice(i, 1, data);
      }
    })
  },
  removePart (state, { skidId, partId }) {
    state.skids.forEach(skid => {
      if (skid.id == skidId) {
        skid.parts.forEach((part, i) => {
          if (part.id == partId) {
            skid.parts.splice(i, 1);
          }
        })
      }
    })
  } 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}